import React from "react";
import { Card, Divider, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import PreviewBulkScan from "../../../components/Comman/BulkInwardOutward/PreviewBulkScan";
import BinLocationService from "../../../services/Wash-service/BinLocationService";
import "../../../styles/global-ui.css";

const Wash_BulkInwardPreviewPage = () => {
  const navigate = useNavigate();

const handleConfirmBinInward = async (formatedBinId, addedBy) => {
  try {
    const response = await BinLocationService.bulk_bin_movement(
      formatedBinId,
      addedBy,
      "dispatch_center",
      "washing",
      "inward"
    );

    console.log("Response:", response);

    // ✅ return response to caller
    return response;

  } catch (error) {
    console.error("Error during bin movement:", error);

    // ❗ important → throw so caller can handle
    throw error;
  }
};

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            <span className="page-title-inline">
              <ArrowLeftOutlined
                onClick={() => navigate(-1)}
                className="page-back-icon"
              />
              Bin Inward Preview
            </span>
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Review selected bins before confirming inward movement
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <PreviewBulkScan
          handleConfirmBinInward={handleConfirmBinInward}
          type="inward"
          title="Bin Inward Preview"
        />
      </Card>
    </div>
  );
};

export default Wash_BulkInwardPreviewPage;